import axios from "axios"
export function getAdvertiserImpressionsAndCampaigns(token, advertiserId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getImpressionsCampaigns?advertiserId=${advertiserId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}